import {MdAddCircleOutline} from 'react-icons/md';

type Props = {
  onClick: () => void;
  text?: string;
  disabled?: boolean;
};

export const AddStepButton = ({
  onClick,
  text = '次の選考予定を追加',
  disabled = false,
}: Props) => {
  return (
    <button
      type="button"
      className="flex items-center justify-center gap-8 flex-shrink-0 text-white text-base bg-primary rounded-full px-16 py-12 hover:opacity-80 transition-opacity disabled:text-black-2 disabled:bg-disabled-1 disabled:cursor-not-allowed"
      onClick={onClick}
      disabled={disabled}
    >
      <MdAddCircleOutline size={20} />
      <span className="font-bold">{text}</span>
    </button>
  );
};
